// extracted by mini-css-extract-plugin
export default {"venchyFixedSide":"venchySpeaking_venchyFixedSide__rejDG","image":"venchySpeaking_image__OP2SJ"};